import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { RequestDto } from "../dto/request.dto";
import { TransactionDto } from "../dto/transactions.dto";
import { RequestForm } from "../entity/request.entity";
import { VisitorEntry } from "../entity/security.entity";

@Injectable()
@EntityRepository(RequestForm)
export class RequestRepo extends Repository<RequestForm>{

    async checkInData(){
        let query = this.createQueryBuilder('rf')
        .leftJoin(VisitorEntry,'v','v.request_id = rf.request_id')
        .where(`DATE(check_in) != DATE(NOW()) and status_by_hod = 'APPROVED' and status_by_hr = 'APPROVED' and visitor_departuredate >DATE(NOW())`)
        const queryData = await query.getMany();
        return queryData;

    }
    
    async historyData(req:RequestDto) : Promise<TransactionDto[]>{
        let query = this.createQueryBuilder('rf')
        .select('COUNT(visitor_name) AS no_of_visitors , status_by_hod AS hod_status , status_by_hr AS hr_status, Date(created_at) as created_at')
        .where(`visitor_email = '${req.visitorEmail}'`)
        .groupBy('status_by_hod , status_by_hr , Date(created_at)')
        .orderBy('Date(created_at)')
        const queryData = await query.getRawMany();
        return queryData;

    }
}